import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { ExperiencePolicy } from '../../../types/policy';
import PolicyModal from '../../Policies/PolicyModal';
import { capitalizeName } from '../../../../shared/utils';
import { bookingPoliciesContent } from '../../Policies/PolicyForm';

interface Props {
    policy: ExperiencePolicy;
}

const ExperiencePolicyCard = ({ policy }: Props) => {
    const theme = useTheme();
    const MAX_DESCRIPTION_LENGTH: number = 35;
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const myRef = useRef<HTMLDivElement>(null);
    const truncateText = (description?: string) => {
        if (!description) return '';

        if (description.length > MAX_DESCRIPTION_LENGTH) {
            return description.substring(0, MAX_DESCRIPTION_LENGTH - 3) + '...';
        } else {
            return description;
        }
    };

    const cancellationPolicyDetails = bookingPoliciesContent.find(
        (item) => item.value === policy?.cancellationType,
    );

    return (
        <Stack>
            <Card
                onClick={() => setModalOpen(true)}
                sx={{
                    transformOrigin: 'center',
                    height: '100%',
                    minHeight: '150px',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease',

                    '&:hover': {
                        transform: 'scale(1.02)',
                    },
                }}
                style={{ flex: 1 }}
            >
                <Grid
                    ref={myRef}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'custom.cardActionBackground',
                        animation: 'none',
                        '@keyframes background-change': {
                            '0%': {
                                backgroundColor: theme.palette.faded.main,
                            },

                            '100%': {
                                backgroundColor: 'custom.cardActionBackground',
                            },
                        },
                    }}
                >
                    <CardContent
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            paddingTop: 2,
                            height: '60px',
                            gap: 1,
                        }}
                    >
                        <Stack
                            direction='row'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <Typography
                                variant='h5'
                                sx={{ color: 'primary.main' }}
                            >
                                {truncateText(capitalizeName(policy?.name))}
                            </Typography>
                        </Stack>
                    </CardContent>
                </Grid>
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                        height: '100px',
                        overflow: 'auto',
                        paddingBottom: '0 !important',
                        pl: '30px !important',
                    }}
                >
                    {cancellationPolicyDetails?.items?.length
                        ? cancellationPolicyDetails.items
                              .slice(0, 2)
                              .map((text, index) => (
                                  <Typography
                                      key={index}
                                      component='li'
                                      variant='body2'
                                  >
                                      {index === 1 ? truncateText(text) : text}
                                  </Typography>
                              ))
                        : null}

                    <Typography
                        sx={{ fontSize: '12px', textDecoration: 'underline' }}
                    >
                        {' '}
                        Show details
                    </Typography>
                </CardContent>
            </Card>

            {cancellationPolicyDetails && (
                <PolicyModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    policy={policy}
                    cancellationPolicyDetails={cancellationPolicyDetails}
                />
            )}
        </Stack>
    );
};

export default ExperiencePolicyCard;
